import axios from 'axios';
import { baseUrl } from '../../config';
import api from './api';
import { showError, showSuccess } from '../../utils/alert';

export const loginService = async ({ email, password, entityId,rememberMe }) => {
  try {
    // Match backend payload
    const response = await axios.post(`${baseUrl}login/login`, {
      loginName: email,
      password: password,
      entityId: entityId,
      channelId: 1,
    });

    
    const data = response.data;

    if (data.status !== 'Success') {
    
      showError(response?.message || "Login failed")
      throw new Error(data.message || 'Login failed');
    }
     //showSuccess("login successful");

    const result = data.result;


    // Save tokens & userdata to localStorage
    localStorage.setItem('userData', result.userData);
    localStorage.setItem('accessToken', result.accessToken.replace(/"/g, ''));
    localStorage.setItem('refreshToken', result.refreshToken.replace(/"/g, ''));
    localStorage.setItem('tokenExpiryMin', result.tokenExpiryMin);
    //localStorage.setItem("rememberedCredentialsGSG", JSON.stringify({ loginName: email, password: password }));
        if (rememberMe) {
          
          localStorage.setItem("rememberedCredentialsGSGCustomer", JSON.stringify({ loginName: email, password: password }));
        } else {
     
          
          localStorage.removeItem("rememberedCredentialsGSGCustomer");
        }
    return result; // return result to Redux
  } catch (error) {
     
     if(error?.response?.data?.status == "Failure"){
      showError(error?.response?.data?.message || "Login failed")
     }
    throw new Error(error.response?.data?.message || 'Login failed');
  }
};
export const getdefaulttaglist = async (payload) => {
    try {
      const response = await axios.get(`${baseUrl}customer/getdefaulttaglist`, {
        params: payload, // ✅ sends as query string
    });
    return response.data;
    } catch (error) {
      //handleError(error);
    }
  };

   export const upsertcustomer = async (payload) => {
    try {
      const response = await axios.post(`${baseUrl}customer/upsertcustomer`, payload);   
      showSuccess("Registration successful");
      return response.data;
    } catch (error) {
    
      
      showError(error?.response?.data?.message);
      //handleError(error);
    }
  };

  export const uploadcustomerattachments = async (payload) => {
    try {
      const response = await axios.post(`${baseUrl}customer/uploadcustomerattachments`, payload);   
 
      return response.data;
    } catch (error) {
      //handleError(error);
    }
  };
  export const getattachmentname = async (payload) => {
    try {
      const response = await axios.get(`${baseUrl}customer/getattachmentname`, {
        params: payload, // ✅ sends as query string
    });
    return response.data;
    } catch (error) {
      //handleError(error);
    }
  };

  
export const forgotpassword = async (payload) => {
    try {
      const response = await axios.post(`${baseUrl}login/forgotpassword`, payload);   
      showSuccess("Submited successful");
      return response.data;
    } catch (error) {
      
      showError(error?.response?.data?.message);
      //handleError(error);
    }
  };

export const resetpassword = async (payload) => {
    try {
      const response = await axios.post(`${baseUrl}login/resetpassword`, payload);   
      showSuccess("Submited successful");
      return response.data;
    } catch (error) {
      showError(error?.response?.data?.message);
      //handleError(error);
    }
  };